import { render, staticRenderFns } from "./PortalAccessCard.vue?vue&type=template&id=ccd172e8&scoped=true&"
import script from "./PortalAccessCard.vue?vue&type=script&lang=ts&"
export * from "./PortalAccessCard.vue?vue&type=script&lang=ts&"
import style0 from "./PortalAccessCard.vue?vue&type=style&index=0&id=ccd172e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd172e8",
  null
  
)

export default component.exports